import { useState } from 'react';
import { ProfileLogo, Text } from 'src/components';
import { Skeleton, Tooltip, Alert } from 'antd';
import { useDispatch } from 'react-redux';
import { getInsightHealthTemplatesByIdAction } from '../../store/actions/templatesexchange.action';
import TemplatesExchangeModal from './TemplatesExchangeModal';
import './TemplatesExchangeModal.scss';
import { VerifiedIcon } from 'src/icons';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const TemplatesExchangeInsight = ({ insightHealthTemplatesList }) => {
  const dispatch = useDispatch();
  const insightLogo =
    'data:image/png;base64,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';

  const { user } = useAuth();

  const [templateOpen, setTemplateOpen] = useState(false);
  const [templateId, setTemplateId] = useState(null);

  const handleTemplateOpen = (template_id) => {
    analytics.track('Clicked Note Template Tile', { email: user?.email });
    setTemplateId(template_id);
    dispatch(getInsightHealthTemplatesByIdAction(template_id, setTemplateOpen));
  };

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  };

  const templateFields =
    insightHealthTemplatesList?.map((template) => ({
      id: template?.template?.template_id,
      name: template?.template?.name,
      detail: 'Section headers',
      sections: template?.template?.body?.sections.map(
        (section) => section?.name
      ),
      //   generate: template?.encounter_count,
      //   users: template?.user_count,
      //   sharedTemp: template?.practitioner_template_overrides_count,
      //   practitionerName: template?.practitioner_name,
    })) || [];

  return (
    <div className="templatesexchange ">
      <div className="flex gap-4 px-10 relative z-20 min-h-[80vh]">
        {templateFields.length === 0 ? (
          <div className="absolute inset-0 flex justify-center items-center z-10 w-full">
            <div className="p-10 rounded-lg text-base font-medium text-gray">
              <Alert
                message="No templates available. Insight Health curated templates will be displayed here soon."
                type="info"
                showIcon
              />
            </div>
          </div>
        ) : (
          <div className="grid grid-rows-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-x-24 gap-y-5 px-10 mt-5 w-full">
            {templateFields.map((item, i) => {
              const id = item.id;
              const heading = item.name;
              const desc = item.detail;
              const sect = item.sections;
              return (
                <div key={i} className="pb-2">
                  <div
                    className="ant-dropdown-link"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div className="profile-wrapper flex items-center pt-3 gap-1">
                      <ProfileLogo
                        base64Image={insightLogo}
                        name={`Insight Health`}
                        className="profile-popover-logo mr-1 sm:mr-2 lg:mr-2"
                        practitioner_name={`Insight Health`}
                      />
                      <Text
                        type={'span'}
                        className="user-name mr-1 sm:mr-2 lg:mr-2 text-black"
                      >
                        <div id="template_owner" className="font-medium">
                          {`Insight Health`}
                          <VerifiedIcon />
                        </div>
                        <div className="text-xs text-gray-500 ">
                          Curated by Insight Health
                        </div>
                      </Text>
                    </div>
                  </div>
                  <div
                    className={`card h-72  bg-white border-2 shadow-xl border-transparent rounded-xl mt-4`}
                  >
                    <div
                      className="card-title relative text-base text-black font-medium text-center border-transparent shadow-md rounded-xl p-4 m-3 border-2"
                      style={{
                        backgroundImage:
                          'linear-gradient(to right, #ecf9ff, #ebf8fe, #e9f7fe, #e8f6fd, #e7f5fd, #e7f5fd, #e7f5fd, #e7f5fd, #e8f6fd, #e9f7fe, #ebf8fe, #ecf9ffc2)',
                      }}
                    >
                      <div className="flex items-center text-wrap w-1/2 2xl:w-full text-sm">
                        {heading}
                      </div>
                      <span
                        className="lg:text-sm text-[#018749] bg-[#caffca] text-xs absolute top-2 right-2 flex items-center justify-center rounded-full h-8 px-3 cursor-pointer"
                        onClick={() => {
                          handleTemplateOpen(id);
                        }}
                      >
                        Get note template
                      </span>
                    </div>
                    <div className="pl-3 cursor-pointer relative ">
                      {sect && sect.length > 0 ? (
                        <div
                          className="card-text lg:h-full h-[11rem] overflow-y-auto cursor-pointer flex  flex-wrap justify-between px-4 pt-2 pb-3 "
                          onClick={() => {
                            handleTemplateOpen(id);
                          }}
                        >
                          <div>
                            <div className="header&section ">
                              <div className="text-black text-lg py-1 font-medium">
                                {desc}
                              </div>
                              <Tooltip
                                title={
                                  <div
                                    className={`pt-1 overflow-y-auto ${sect && sect.length > 12 ? 'h-[35rem]' : 'h-fit '} w-[15rem]`}
                                  >
                                    {sect &&
                                      sect.length > 0 &&
                                      sect.map((sec, j) => (
                                        <div key={j}>
                                          <div className="text-black pb-1">
                                            <div>{sec}</div>
                                            <div>
                                              <Skeleton.Input
                                                style={{
                                                  width: 200,
                                                  height: 10,
                                                }}
                                                active
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                }
                                placement="right"
                                arrow={false}
                              >
                                <div className="pt-3 h-36 overflow-hidden cursor-pointer">
                                  {sect.map((sec, j) => (
                                    <div key={j} className="text-black pb-1">
                                      <div>{sec}</div>
                                      <div>
                                        <Skeleton.Input
                                          style={{ width: 200, height: 10 }}
                                          active
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="cursor-auto text-center text-base font-medium mt-[72px]">
                          There are no template sections
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <TemplatesExchangeModal
        isOpen={templateOpen}
        setIsOpen={setTemplateOpen}
        templateOverrideId={null}
        templateId={templateId}
      />
    </div>
  );
};

export default TemplatesExchangeInsight;
